import { PICKUP_STATUS } from "../../constants";

const PAST_PICKUPS_GRID_FILTERS = {
  allPickups: PICKUP_STATUS.allPickups,
  completed: PICKUP_STATUS.completed,
  voided: PICKUP_STATUS.voided,
  noFreight: PICKUP_STATUS.noFreight,
};

const PAST_PICKUP_GRID_FILTER_LIST = [
  {
    label: 'All Pickups',
    value: PAST_PICKUPS_GRID_FILTERS.allPickups,
    filterFunc: ({ pickup }) => Boolean(pickup)
  },
  {
    label: 'Completed',
    value: PAST_PICKUPS_GRID_FILTERS.completed,
    filterFunc: ({ pickup }) => pickup.isCompleted
  },
  {
    label: 'Voided',
    value: PAST_PICKUPS_GRID_FILTERS.voided,
    filterFunc: ({ pickup }) => pickup.isVoided
  },
  {
    label: 'No Freight',
    value: PAST_PICKUPS_GRID_FILTERS.noFreight,
    filterFunc: ({pickup}) => pickup.isNoFreight,
  },
];

const LAST_ONE_MONTH = 30;

const STATIC_DATE_RANGE_LIST = [
  { label: '7 days', value: 7 },
  { label: '14 days', value: 14 },
  { label: '30 days', value: 30 }
];

export {
  PAST_PICKUP_GRID_FILTER_LIST,
  PAST_PICKUPS_GRID_FILTERS,
  LAST_ONE_MONTH,
  STATIC_DATE_RANGE_LIST
};
